import { MuiAlert } from '@fox/atoms';
import { useFetch } from '../../../common/use-fetch';
import { GetNewsByTagsInputModel, GetNewsByTagsResultModel } from '../../NewsList/contracts';
import { DynamicListCarousel } from '../dynamic-lists-carousel/index';

interface DynamicNewsListProps {
	encodedNewsPageId: string;
	search?: string;
	tags?: string[];
	sortBy?: string;
	dateFrom?: Date;
	dateTo?: Date;
	maxItems?: number;
	rssFeedUrl?: string;
	hideThumbnail?: boolean;
	fadeOutGradientColour?: string;
}
/**Simple block to just render some news items based on filter provided */
export function DynamicNewsList({
	encodedNewsPageId,
	dateFrom,
	dateTo,
	maxItems,
	search,
	sortBy,
	tags,
	hideThumbnail,
	rssFeedUrl,
	fadeOutGradientColour
}: DynamicNewsListProps) {
	const { error, result } = useFetch<GetNewsByTagsResultModel, GetNewsByTagsInputModel>(
		{
			page: 1,
			pageSize: maxItems > 0 ? maxItems : 5,
			contentId: encodedNewsPageId,
			tags,
			rSSFeedUrl: rssFeedUrl,
			from: dateFrom,
			to: dateTo,
			search,
			sortOldToNew: sortBy === 'Oldest First' ? true : false
		},
		'/Umbraco/Api/NewsSearch/GetNewsByTags',
		'POST',
		[]
	);
	if (error) return <MuiAlert severity="error">{error}</MuiAlert>;

	return !!result?.newsItems?.length ? (
		<DynamicListCarousel
			fadeOutGradientColour={fadeOutGradientColour}
			items={result.newsItems.map((newsItem, i) => {
				return {
					id: i,
					position: i,
					props: { newsItem, hideThumbnail, id: i },
					type: 'news'
				};
			})}
		/>
	) : (
		<MuiAlert severity="info">No news items to display</MuiAlert>
	);
}
